import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { authenticateWithBankID } from "../services/ApiService";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import bankIdLogoSrc from "../assets/images/BankID_logo_white.png";
import videoSrc from "../assets/onboarding/ziplink5.mp4";
import {shouldBypassAuth} from "../services/utils/devAuthBypass";

const OnboardingScreenVideo = () => {
  const navigate = useNavigate();
  const { token } = useAuth();

  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [buttonText, setButtonText] = useState("Logga in med BankID");

  useEffect(() => {
    if (token) {
        if (shouldBypassAuth() || token) {
            navigate("/products");
        }
      console.log("User already has a token, redirecting to /products");
      navigate("/products");
    }
  }, [navigate, token]);

  const handleButtonPress = async (e) => {
    e.preventDefault();

    setButtonDisabled(true);
    setButtonText("Behandlar...");

    try {
      const authResponse = await authenticateWithBankID();
      if (authResponse?.orderRef && authResponse?.autoStartToken) {
        console.log("Saving BankID session info to sessionStorage...");
        sessionStorage.setItem("bankid_orderRef", authResponse.orderRef);
        sessionStorage.setItem("bankid_autoStartToken", authResponse.autoStartToken);

        // Go to BankID start page
        navigate("/bankid-start");
      } else {
        console.error("Authentication failed: No orderRef or autoStartToken.");
        setButtonDisabled(false);
        setButtonText("Logga in med BankID");
      }
    } catch (error) {
      console.error("BankID error:", error);
      setButtonDisabled(false);
      setButtonText("Logga in med BankID");
    }
  };

  return (
      <Container>
        <VideoWrapper>
          <BackgroundVideo src={videoSrc} autoPlay muted loop playsInline />
        </VideoWrapper>
        <ContentContainer>
          <TopLogoContainer></TopLogoContainer>
          <ButtonContainer>
            <LoginButton onClick={handleButtonPress} disabled={buttonDisabled}>
              <Logo src={bankIdLogoSrc} alt="BankID Logo" />
              <ButtonText>{buttonText}</ButtonText>
            </LoginButton>
          </ButtonContainer>
        </ContentContainer>
      </Container>
  );
};

export default OnboardingScreenVideo;

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const VideoWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

const BackgroundVideo = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ContentContainer = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
`;

const TopLogoContainer = styled.div`
  width: 60%;
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

const ButtonContainer = styled.div`
  width: 80%;
  display: flex;
  justify-content: center;
  margin-bottom: 100px;
`;

const LoginButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  background-color: ${({ disabled }) => (disabled ? "#666" : "#000")};
  border-radius: 100px;
  width: 100%;
  max-width: 350px;
  border: none;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${({ disabled }) => (disabled ? "#666" : "#111")};
  }
`;

const ButtonText = styled.span`
  color: white;
  font-size: 18px;
  margin-left: 10px;
`;

const Logo = styled.img`
  width: 50px;
  height: 50px;
`;